import React, { useState, useEffect } from 'react';
import Button from '@mui/material/Button';
import { useForm, Controller } from 'react-hook-form';
import { Box, Divider, TextField, Typography } from '@mui/material';
import moment from 'moment';
import Swal from 'sweetalert2';

import { Modal } from '../../../components/BootstrapToMUI';
import request from '../../../services/Request';
import { Checkbox } from '@mui/material';

// Read-only member details. Shown here so the table can stay narrow;
// none of it is editable from this screen.
function DetailRow({ label, value }) {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'baseline',
        gap: 2,
        py: 0.6,
      }}
    >
      <Typography variant="body2" color="text.secondary" sx={{ flexShrink: 0 }}>
        {label}
      </Typography>
      <Typography variant="body2" sx={{ fontWeight: 500, textAlign: 'right', wordBreak: 'break-all' }}>
        {value === undefined || value === null || value === '' ? '-' : value}
      </Typography>
    </Box>
  );
}

export default function EditMemberModal(props) {
  const { data, setReflesh, reflesh, id, setMobile, ...rest } = props;
  const defaultValues = {
    points: data?.points || 0,
    active: data?.active || false,
  };
  const { handleSubmit, reset, watch, control, register, setValue } = useForm({ defaultValues });

  const watchAll = watch();

  useEffect(() => {
    if (props.show) {
      console.log('rowData', data);
      reset(defaultValues);
    }
  }, [props.show]);

  const onSubmit = async (formData) => {
    console.log('formData', formData);
    if (formData.pg_radio === '0') {
      formData.pg_point = 0;
    }

    request({
      method: 'patch',
      url: `/clientUser/editClientUser`,
      data: {
        _id: data?._id,
        points: formData.points,
        active: formData.active,
      },
    }).then(() => {
      data.points = formData.points;
      data.active = formData.active;
      Swal.fire({
        title: 'Success',
        text: 'Member setting has been successfully updated',
      }).then(() => {
        props.onHide();
      });
    });

    // return console.log('formData', formData);
  };

  return (
    <Modal className="modal-w" {...rest} centered size="lg">
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">Edit Member setting</Modal.Title>
      </Modal.Header>
      <Modal.Body className="modal-body">
        <Box sx={{ px: 5, pb: 1, textAlign: 'left' }}>
          <DetailRow label="Username" value={data?.username} />
          <DetailRow label="Email" value={data?.email} />
          <DetailRow label="Phone" value={data?.phone} />
          {data?.pin && <DetailRow label="Pin" value={data.pin} />}
          <DetailRow
            label="Member since"
            value={data?.createdAt ? moment(data.createdAt).format('MM/DD/YYYY') : null}
          />
          <DetailRow
            label="Last purchase"
            value={data?.last_purchase ? moment(data.last_purchase).format('MM/DD/YYYY') : null}
          />
          <DetailRow label="Total orders" value={data?.order_qtt || 0} />
          <Divider sx={{ mt: 1.5 }} />
        </Box>

        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          style={{ textAlign: 'center', padding: '0 40px' }}
        >
          <div className="d-flex flex-column">
            <div
              item
              xs={12}
              style={{
                display: 'flex',
                alignContent: 'center',
                alignItems: 'center',
                fontSize: '16px',
              }}
            >
              <Controller
                name="active"
                control={control}
                render={({ field }) => <Checkbox {...field} checked={watchAll.active} />}
              />
              <span>Active</span>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <TextField
                variant="outlined"
                margin="normal"
                type="number"
                required
                fullWidth
                label="Points"
                name="points"
                inputProps={{ min: 0 }}
                autoComplete="points"
                value={watchAll.points}
                {...register('points')}
              />
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const currentValue = parseInt(watchAll.points || 0, 10);
                  setValue('points', currentValue + 100); // Add 100
                }}
              >
                +100
              </Button>
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  const currentValue = parseInt(watchAll.points || 0, 10);
                  setValue('points', Math.max(currentValue - 100, 0)); // Subtract 100, prevent going below 0
                }}
              >
                -100
              </Button>
            </div>
          </div>

          <Button variant="contained" color="primary" type="submit" className="mt-3">
            Submit
          </Button>
        </form>
      </Modal.Body>
    </Modal>
  );
}
